import { render, staticRenderFns } from "./CheckboxField.vue?vue&type=template&id=324e243e&scoped=true&"
import script from "./CheckboxField.vue?vue&type=script&lang=js&"
export * from "./CheckboxField.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxField.vue?vue&type=style&index=0&id=324e243e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324e243e",
  null
  
)

export default component.exports